import request from '../setup/request';
const user = {
  /**
   * 获取联系人列表
   *
   */
  getContactList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.contact.getList',
    });
  },
  /**
   * 添加联系人
   *
   */
  addContact(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.contact.add',
    });
  },
  /**
   * 删除联系人
   * @returns {AxiosPromise}
   */
  deleteContact(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.contact.del',
    });
  },
  /**
   * 编辑联系人
   * @returns {AxiosPromise}
   */
  editContact(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.contact.edit',
    });
  },
  /**
   * 编辑发票 add del edit
   * @returns {AxiosPromise}
   */
  editInvoice(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.user.editInvoice',
    });
  },
  /**
   * 获取发票列表
   * @returns {AxiosPromise}
   */
  getInvoiceList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.user.getInvoice',
    });
  },
  /**
   * 开发票
   * @returns {AxiosPromise}
   */
  creatInvoice(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.user.invoice',
    });
  },
  /**
   * 发票详情
   * @returns {AxiosPromise}
   */
  getInvoiceDetail(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.user.invoiceDetail',
    });
  },
  /**
   * 查询历史发票购买方信息
   * @returns {AxiosPromise}
   */
  getInvoiceSearch(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.user.invoiceSearch',
    });
  },
};
export default user;
